import { jsxs, jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-date-range.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSDateRangeButton = ({
  className,
  result
}) => {
  const {
    accessibilityMessage,
    analytics,
    dateText,
    onClickCallback,
    selected = false,
    text,
    textTheme
  } = result;
  const onClickCapture = () => {
    analytics && analyticsTracker(analytics);
    onClickCallback && onClickCallback();
  };
  const buttonClassNames = getClassNameList(className, {
    // eslint-disable-next-line no-useless-computed-key
    ['selected']: selected,
    [`${textTheme}`]: textTheme
  });
  const buttonTextClass = getClassNameList(`uitk-date-range-button-text`);
  const buttonDateTextClass = getClassNameList(`uitk-date-range-button-date-text`);
  return jsxs("button", {
    type: "button",
    "aria-selected": selected,
    "aria-label": accessibilityMessage,
    className: buttonClassNames,
    onClickCapture: onClickCapture,
    role: "tab",
    children: [jsx("span", {
      className: buttonDateTextClass,
      children: dateText
    }), jsx("span", {
      className: buttonTextClass,
      children: text
    })]
  });
};
export { EGDSDateRangeButton };